<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">

          <CCardGroup>
            <CCard class="p-4">

              <CCardBody>
                <CForm @submit.prevent="login(item)">

                  <center>
                    <div class="image-container">
                      <img src="../../assets/icons/logo_login.jpg" alt="Logo LyBFlow" class="responsive-image" />
                    </div>
                    <h3>Iniciar sesión</h3>
                    <p class="text-muted" style="font-size: 1em;">Ingresa con tus credenciales </p>
                  </center>

                  <!--email-->
                  <CInput :disabled="peticion" placeholder="Email" v-model.trim="$v.item.email.$model" class="mb-0">
                    <template #prepend-content>
                      <b-icon icon="mailbox" aria-hidden="true"></b-icon>
                    </template>
                  </CInput>


                  <p class="text-danger" style="font-size: .7em; float: right;"
                    v-if="$v.item.email.required && !$v.item.email.email">Email incorrecto</p>
                  <!--password-->
                  <b-input-group class="mt-3 ">
                    <template #prepend>
                      <b-input-group-text><b-icon icon="unlock"></b-icon></b-input-group-text>
                    </template>
                    <b-form-input v-model.trim="$v.item.password.$model" :type="typeInput" placeholder="contraseña"
                      style="border-right: none ;" />
                    <b-input-group-append @click="changeIcon()">
                      <b-input-group-text style="background:#fff;border-left: none ;">
                        <b-icon :icon="iconoView" />
                      </b-input-group-text>
                    </b-input-group-append>
                  </b-input-group>


                  <!--boton ingresar-->

                  <CCol col="12" class="text-center mt-2">
                    <b-button :variant="colorlogin" type="submit" block :disabled="$v.$invalid || peticion"
                      v-if="!peticion">Ingresar
                    </b-button>
                  </CCol>

                  <!--botones-->
                  <b-row class="overflow-x">
                    <div class="text-center col-lg-4 col-xs-12">
                      <CButton class=" btn-ligth mt-3" href="/code_invitation" style="width: max-content;">
                        <b-icon-person></b-icon-person> Crear cuenta
                      </CButton>
                    </div>

                    <div class="text-center col-lg-2 col-xs-12 "></div>

                    <div class="text-center col-lg-4 col-xs-12  ">
                      <CButton color="link" class=" mt-3" to="forgot_password" style="width: 100%;  white-space: nowrap;">
                        ¿Olvidaste tu contraseña?</CButton>
                    </div>
                  </b-row>
                  <Loader v-if="peticion"></Loader>

                </CForm>
              </CCardBody>

            </CCard>
          </CCardGroup>

        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import "regenerator-runtime/runtime";

import repologin from "./repologin.js";
import Service from "@/services/SessionStorage";
import alertas from "@/assets/repositoriosjs/alertas.js";
import { required, minLength, email } from "vuelidate/lib/validators";
import Loader from "../media/Loader.vue";
//import PacmanLoader from "vue-spinner/src/PacmanLoader.vue";


export default {
  data: () => {
    return {
      typeInput: 'password',
      iconoView: 'eye-slash',
      valI: false,
      variable: "cil-lock-locked",
      item: {
        password: '',
        email: ''
      },
      userId: "",
      color: "#fdd901",
      peticion: false
    };
  },
  computed: {
    colorlogin() {
      if (this.$v.$invalid) {
        return "dark";
      } else {
        return "primary";
      }
    },
   /* msj() {
      if (this.$v.$invalid) {
        return "Ingresa correo y/o password válido";
      } else {
        return "Ingresar";
      }
    }*/
  },
  validations: {
    item: {
      password: {
        required,
        minLength: minLength(6)
      },
      email: {
        required,
        email
      }
    }
  },
  methods: {
    async login(item) {
      let self = this;
      let alert = alertas();
      self.peticion = true;
      let access = repologin();
      try {
        let result = await access.login(item);

        self.coderesponse(result, self, alert);
      } catch (error) {
        alert.invalid();
      } finally {
        self.peticion = false;
        // self.resetlogin();
      }
    },
    coderesponse(result, self, alert) {
      return result.data.code == 200
        ? self.success(result.data, self, alert)
        : result.data.code == 204
          ? self.confirmEmail(alert, result)
          : result.data.code == 403
            ? self.denegado(alert)
            : result.data.code == 401
              ? self.credentialinvalid(alert)
              : result.data.code == 202
                ? self.pendiente(alert) ///pendiente
                : self.error500(alert);
    },
    success(result, self, alert) {
      let service = Service(); //session storage
      result.roles = result.user.menuroles;

      if (result.roles.length > 0) {
        const redirect = this.$route.query.redirect || '/'; // Si el usuario intento acceder a una url antes de iniciar sesion, lo va a redirigir 
        result.user.photo == null || result.user.photo == ""
          ? "" : (result.user.photo = self.$prefijoamazon + result.user.photo);
          //$store vuex
        self.$store.commit("setUserAction", result);
        self.$store.commit("set", "fotouser", result.user.photo);
        self.$store.commit("setmetodo",result.sistema.metodo == 2 ? true : false);

        result.token = self.CryptoJS.AES.encrypt(result.token.toString(), self.$keysecret).toString();

        service.logininicial(result);

        result.nuevo == 1 || result.nuevo == null || result.nuevo == "NULL"
          ? self.$router.push(`/settings`)
          : self.$router.push(redirect);
      } else {
        self.sinroles(alert);
      }
    },
    changeIcon() {
      this.valI = !this.valI;
      this.iconoView = (this.valI) ? 'eye' : 'eye-slash';
      this.typeInput = (this.valI) ? 'text' : 'password';
    },
    resetlogin() {
      this.item.password = "";
      this.item.email = "";
    },
    pendiente(alert) {
      alert.pending();
    },
    denegado(alert) {
      alert.denegado();
    },
    sinroles(alert) {
      alert.sinroles();
      return false;
    },
    credentialinvalid(alert) {
      alert.invalid();
    },
    confirmEmail(alert, msj) {
      alert.sincorfirmaremail(msj.data.message);
    },
    error500(alert) {
      alert.errorservidor();
    },

  },

  name: "Login",
  metaInfo:{
    title: 'Login',
  },
  created() {
    let service = Service();
    service.activaRegistro(null);
    service.logout();
    this.resetlogin();
    this.$store.commit("setUserAction", null);
  },

  components: {
    Loader
  }
  
};
</script>

<style scoped>
#requerido:after {
  content: '*';
  margin-left: 3px;
  color: red;
  font-weight: bold;
}
.btn-view {
  border: 1px solid #ced4da;
  background: #fff;
}

.btn-primary {
  color: #fff;
  /* background-color: rgb(31, 104, 172); Color azul*/
  background-color: rgba(0, 129, 194, 255);
  /* background-color: teal; */
  border-color: #005a5a;
}

.btn-primary:hover {
  color: #fff;
  background-color: rgba(0, 145, 194, 255);
  border-color: #005a5a;
}

/* Color para boton info en bootstrap */
.btn-info {
  color: #fff;
  /* background-color: rgb(31, 104, 172); */
  background-color: #229ca5;
  border-color: #005a5a;
}

.btn-info:hover {
  color: #fff;
  background-color: #3b9c96;
  border-color: #005a5a;
}

button {
  outline: none !important;
  border: none;
  background: transparent;
}

button:hover {
  cursor: pointer;
}


.image-container {
  width: 90%;
  /* Establece el ancho del contenedor de la imagen */
}

.responsive-image {
  width: 100%;
  /* Hace que la imagen ocupe el ancho completo del contenedor */
  height: auto;
  /* Permite que la altura se ajuste automáticamente */
}

.button-container {
  width: 100%;
  /* Establece el ancho del contenedor del botón */
}

.overflow-x {
  overflow-x: auto;
}
</style>



